import type { ReactNode } from 'react';
import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface ActionProps {
  className?: string;
  icon?: ReactNode;
  title: string;
  onClick?: () => void;
}

export const Action = (props: ActionProps) => {
  return (
    <div
      className={cn(
        'flex cursor-pointer items-center gap-3 p-6 text-inherit no-underline transition-shadow duration-200',
        'hover:shadow-lg dark:hover:shadow-lg-dark',
        PaletteUtils.isVcfcPalette && 'bg-ghost-white dark:bg-eerie-black',
        PaletteUtils.isInsigniaPalette && 'bg-ice dark:bg-light/5',
        props.className,
      )}
      onClick={props.onClick}
    >
      {props.icon && (
        <div
          className={cn(
            'flex h-12 w-12 flex-none items-center justify-center rounded-3xl text-ice dark:bg-primary',
            PaletteUtils.isInsigniaPalette && 'bg-soft-black',
            PaletteUtils.isVcfcPalette && 'bg-primary',
          )}
        >
          {props.icon}
        </div>
      )}
      <Text className={cn(PaletteUtils.isInsigniaPalette && 'dark:!text-primary')} weight='semibold' size='xl'>
        {props.title}
      </Text>
    </div>
  );
};
